export function createAfterFormSubmitSuccessEvent(payload) {
    return createAfterFormSubmitEvent(true, payload);
}
export function createAfterFormSubmitFailEvent(payload) {
    return createAfterFormSubmitEvent(false, payload);
}
function createAfterFormSubmitEvent(successful, payload) {
    return new CustomEvent("d365mkt-afterformsubmit", { bubbles: true, detail: { successful: successful, payload: payload } });
}
